import { forwardRef, useEffect, useState } from "react";
import Select from "react-select";
import { stockService } from "../../../services/stock.service";
import { IOption } from "Dashboard/domain/IOption";
import { IStockInput } from "Dashboard/scenes/Stock/domain/IStockInput";

const InputSelect = forwardRef<any, any>((props, ref) => {
  const [isLoading, setIsLoading] = useState(true);
  const [options, setOptions] = useState<IOption[]>([]);
  const [value, setValue] = useState<IOption | undefined>(undefined);

  useEffect(() => {
    async function getData() {
      try {
        const abortCtrl = new AbortController();
        const inputs = await stockService.getStockInputs(
          { stock: "Lager" }, { fetchMode: "replace" }, abortCtrl.signal
        );
        const op = inputs.inputs.map((input) => {
          return {
            label: input.item.name,
            value: input.inputId,
          };
        });
        setOptions(covertInputsToOptions(inputs.inputs));
        setIsLoading(false);
      } catch (err) {
        console.log(err);
      }
    }
    try {
      if (props.inputs) {
        if (props.inputs.length !== 0) {
          setOptions(covertInputsToOptions(props.inputs));
          setIsLoading(false);
        }
      } else {
        getData();
      }
    } catch (err) {
      console.log(err);
    }
  }, [props.inputs]);

  function covertInputsToOptions(inputs: IStockInput[]): IOption[] {
    return inputs.map((input) => ({
      label: input.item.name,
      value: input.inputId,
    }));
  }
  const handleChange = (newValue: any, actionMeta: any) => {
    setValue(newValue);
    props.onChange(newValue ? newValue.value : null);
  };

  useEffect(() => {
    const values = options.filter((o) => o.value === props.selectedInputId);
    if (values[0]) {
      setValue(values[0]);
    } else {
      setValue(undefined);
    }
  }, [options, props.selectedInputId]);

  return (
    <Select
      styles={props.customStyles}
      menuPosition="fixed"
      ref={ref}
      options={options}
      value={value}
      onChange={handleChange}
      placeholder={""}
      noOptionsMessage={() => "Ne postoji"}
      isLoading={isLoading}
      {...{ error: props.error }}
    />
  );
});

export default InputSelect;
